import { pdfjs } from 'react-pdf';
import { toDataUrl } from '../common/file.lib';
import { imageToFile } from './utils/image.lib';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

export const toImage = async (file: File | string): Promise<string> => {
  if (typeof file === 'string') {
    const asFile = await imageToFile(file, 'document');
    if (!asFile) {
      throw new Error('Unable to download file');
    }
    file = asFile;
  }

  const data = await toDataUrl(file);

  if (!data) {
    throw new Error('Unable to open file');
  }

  // verbosity: ERRORS silences benign font-sanitizer warnings (e.g.
  // "TT: undefined function") that pdf.js logs for embedded fonts in user PDFs.
  const pdf = await pdfjs.getDocument({
    url: data,
    verbosity: pdfjs.VerbosityLevel.ERRORS,
  }).promise;
  const canvas = document.createElement('canvas');
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 1 });
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Unable to preview file');
  }

  canvas.height = viewport.height;
  canvas.width = viewport.width;
  await page.render({ canvasContext: context, canvas, viewport }).promise;

  const image = canvas.toDataURL();

  canvas.remove();

  return image;
};

export const triggerPrint = (href: string): void => {
  const oldFrame = document.getElementById('pdfPrinterFrame');
  if (oldFrame) {
    oldFrame.remove();
  }

  const iframe = document.createElement('iframe');
  iframe.id = 'pdfPrinterFrame';
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.src = href;

  // Print when loaded
  iframe.onload = () => {
    if (!iframe.contentWindow) {
      console.error('Print failed, cannot access frame');
      return;
    }

    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (err) {
      console.error('Printing failed:', err);
    }
  };

  document.body.appendChild(iframe);
};
